
import { Component, inject, OnChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { ModelService } from '../../../services/model-service';
import { ConfigurationSection, UserStateService } from '../../../services/user-state.service';
import { GuruEntity } from '../../../model/guru-entity';
import { SelectionUtils } from '../../selection-utils';

@Component({
  selector: 'app-enviro-kit-coil-options',
  imports: [MatIcon, FormsModule],
  templateUrl: './enviro-kit-coil-options.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './enviro-kit-coil-options.component.css'
})
export class EnviroKitCoilOptionsComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  coilConstructionSelection!: GuruEntity;
  autoAirVentsSelection!: GuruEntity;
  preHeatSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.COIL_OPTIONS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.coilConstructionSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCoilEndSheet');
    this.autoAirVentsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAutoVents');
    this.preHeatSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPreHeat');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
    entity.Value = newValue;
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
